<template>
  <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color">
    {{ snackbar.message }}
    <template #actions>
      <v-icon @click="snackbar.show = false" icon="mdi-close"/>
    </template>
  </v-snackbar>
</template>

<script setup>
import {useSnackbarStore} from "@/stores/snackBarStore";

const {snackbar} = useSnackbarStore();
</script>

<style scoped>

</style>
